// extracted by mini-css-extract-plugin
export default {"control":"Product_control__sYqBK","richText":"Product_richText__xP83D"};